import { AskUs } from "@component/Widget/AskUs/AskUs";
import { faHandshakeSimple as farHandshakeSimple } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faCircleInfo as fasCircleInfo } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgLogo from "@img/logos/bankmonitor-white.svg";
import imgSuperman from "@img/superman.png";
import { faBankmonitor } from "@ui/fortawesome/bankmonitor";
import { Button, LandingContainer } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
/**
 * @Routing
 *
 * @title "A Bankmonitorról"
 * @description "Tudj meg mindent a Bankmonitorról!"
 * @route "/a-bankmonitorrol/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<LandingContainer
					size="lg"
					bgClassName="bg-trianglify-purple bg-border-bottom"
					className="text-center"
					bgColor="#c33350"
				>
					<h1>
						<img src={imgLogo} alt="A Bankmonitorról" width="800" height="200" loading="lazy" />
					</h1>
					<h3 className="display-4 text-white">
						Intézd pénzügyeidet a legnagyobb független banki szakértővel* kalkulációtól a szerződéskötésig!
					</h3>
				</LandingContainer>
				<LandingContainer className="kalkulatorok-box" size="lg">
					<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">Ennyi pénzt spórolunk neked</h2>
					<Row>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<a href="/bankszamla/?link_type=landing-link">
									<strong>legjobb bankszámlával</strong>
								</a>{" "}
								akár <strong>20 ezer forintot</strong> is spórolhatsz évente
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<strong>
									<a href="/lakashitel-kalkulator/?link_type=landing-link">legjobb lakáshitelt</a>
								</strong>{" "}
								választva <strong>500 – 800 ezer forinttal</strong> kevesebb lehet a teljes
								visszafizetésed
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<strong>
									<a href="/megtakaritasok/lakastakarek/?link_type=landing-link">
										legjobb lakástakarék
									</a>
								</strong>{" "}
								<strong>40 – 80 ezer</strong> forint teljes költségelőnyt jelenthet neked
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<a href="/szemelyi-kolcson/?link_type=landing-link">
									<strong>legjobb személyi kölcsönnel</strong>
								</a>{" "}
								<strong>150 – 200 ezer forinttal</strong> kevesebb lehet a teljes visszafizetésed
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<a href="/nyugdij-megtakaritas/?link_type=landing-link">
									<strong>legjobb nyugdíj előtakarékossági</strong>
								</a>{" "}
								megoldással <strong>300 – 500 ezer forintot</strong> spórolhatsz a költségeken
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-white bg-primary h-100 px-2 display-2 mb-0 mr-3 d-flex align-items-center justify-content-center p-2">
								<FontAwesomeIcon icon={faBankmonitor} />
							</div>
							<div>
								A{" "}
								<a href="/megtakaritasok/allampapir/?link_type=landing-link">
									<strong>legjobb megtakarítások</strong>
								</a>{" "}
								megválasztásával <strong>+1 – 2% pont</strong> kamatra tehetsz szert
							</div>
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer bgClassName="argument">
					<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">10 érv a Bankmonitor mellett</h2>
					<Row>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								1.
							</div>
							<div>
								Pénzügyi szakértőként azért nem bankban dolgozunk, mert{" "}
								<b>
									a jó pénzügyi döntésekhez nem <i>egy</i> bankban
								</b>{" "}
								lehet hozzásegíteni az embereket.
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								2.
							</div>
							<div>
								Értünk a pénzügyekhez és <b>érthetővé tesszük számodra is</b> legyen szó bármilyen banki
								kérdésről.
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								3.
							</div>
							<div>
								A Bankmonitoron a <b>bankpiac kínálatának 95%</b>-át megtalálod és objektíven
								összehasonlíthatod
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								4.
							</div>
							<div>
								<b>Segítünk kiválasztani és a legkényelmesebben szerződést kötni</b> bármely banki
								termékre
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								5.
							</div>
							<div>
								Jelentős tapasztalattal, <b>specializált ismeretek</b>kel rendelkeznek a Bankmonitor
								szakértői
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								6.
							</div>
							<div>Rengeteg olyan kérdésre választ adunk, melyet a bankfiókokban hiába tennél fel</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								7.
							</div>
							<div>
								Nehézség, probléma esetén <b>segítünk sínre tenni az ügyedet</b> a bankodban
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								8.
							</div>
							<div>
								Magyarország <b>legpontosabb pénzügyi kalkulátorai</b> és alkalmazásai állnak
								rendelkezésre az objektív döntésekhez
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								9.
							</div>
							<div>
								A Bankmonitoron mindig találsz olyan előnyös pénzügyi megoldást, mely objektíven a
								legjobb termék és <b>egyetlen bankban sem elérhető</b>
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex align-items-center my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-center justify-content-center p-1">
								10.
							</div>
							<div>
								Segítünk neked időt és pénzt spórolni! Megmutatjuk hogyan választhatod ki a legjobb
								terméket és <strong>segítünk a szerződéskötésben</strong> is.
							</div>
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer>
					<Row className="my-5 why handshake">
						<Col xs={12} lg={3} className="d-flex justify-content-center align-items-center">
							<FontAwesomeIcon icon={farHandshakeSimple} className="text-primary" size="7x" />
						</Col>
						<Col xs={12} lg={9} className="border-lg-left">
							<p>
								<b>Miért lehet ingyenes a Bankmonitor szolgáltatása?</b>
								<br />A Bankmonitor bevételei (jelentős részben) a bankoktól származik: számos olyan
								feladatot elvégzünk, ami eredetileg egy bankfiók tevékenységéhez tartozik. Így költséget
								takarítunk meg a bankoknak az ügyfélkiszolgálásunkkal és ebből a költségmegtakarításból
								részesedünk. Számunkra mindegy, hogy mely bank, mely termékét választja az ügyfelünk: a
								legfontosabb, hogy hozzá tudjuk segíteni a jó döntéshez.
							</p>
						</Col>
					</Row>
					<Row className="my-5 why info">
						<Col xs={12} lg={3} className="d-flex justify-content-center align-items-center">
							<FontAwesomeIcon icon={fasCircleInfo} className="text-primary" size="7x" />
						</Col>
						<Col xs={12} lg={9} className="border-lg-left">
							<p>
								<b>Kinek tudunk segíteni?</b>
								<br />
								Ügyfeleink közé tartoznak az olcsóbb bankszámlát választó nyugdíjasoktól, az átlag
								jövedelemmel rendelkező, első lakásukhoz hitelt felvevő fiatalokon keresztül a Svájcban
								privát banki kiszolgálást igénybe vevő legvagyonosabb emberek is. Mindemellett évente
								több száz cégnek segítünk finanszírozási problémáinak megoldásában. Biztosak vagyunk
								benne, hogy számodra is segítséget tudunk nyújtani a legjobb pénzügyi megoldások
								megtalálásában.
							</p>
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer bgClassName="bg-primary bg-border-y">
					<Row>
						<Col xs={12} md={6} className="d-flex justify-content-center align-items-center">
							<img src={imgSuperman} alt="Superman" width="256" height="195" loading="lazy" />
						</Col>
						<Col xs={12} md={6} className="text-white">
							<p>
								<strong>A Bankmonitornál dolgozik Superman?</strong>
							</p>
							<p>
								Nem, szó sincs róla. Nálunk sincs egyetlen olyan kolléga sem, aki mindenhez ért.
								Munkatársaink a saját területük specialistái és a szoros együttműködésen keresztül
								perceken belül választ kapnak egymástól is, ha nem saját területükhöz tartozó kérdésbe
								ütköznek.
							</p>
							<div className="text-center">
								<Button variant="light" size="lg" href="/rolunk/?link_type=landing-button">
									Olvass Rólunk többet!
								</Button>
							</div>
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer bgClassName="bankmonitor-help" size="lg">
					<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">Hogyan segít neked a bankmonitor?</h2>
					<Row>
						<Col xs={12} md={6} className="d-flex my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-start p-1">
								1.
							</div>
							<div>
								<b>
									<u>Objektív tájékozódás:</u>
								</b>{" "}
								Összehasonlító kalkulátoraink használatával pontos képet kaphatsz a bankok által kínált
								termékek különbségéről.
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-start p-1">
								2.
							</div>
							<div>
								<b>
									<u>Szakértői segítség személyesen Neked:</u>
								</b>{" "}
								Egy-egy hitel, vagy megtakarítási kalkuláció/összehasonlítás után számos kérdés merülhet
								még fel (Mi történik, ha változik a kamat? Hogyan hathat az infláció növekedése? Ha
								futamidő vége előtt visszafizetném/felvenném a pénzem?) Ezekre és a hasonló kérdésekre
								személyre szabott válaszokat kapsz tőlünk.
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-start p-1">
								3.
							</div>
							<div>
								<b>
									<u>Segítség a legkényelmesebb szerződéskötésben:</u>
								</b>{" "}
								Mi sem szeretünk bankfiókba járni, ezért azon dolgozunk, hogy Neked se kelljen. (vagy ha
								elkerülhetetlen, akkor előre egyeztetett időpontban, sorban állás nélkül történhessen
								meg)
							</div>
						</Col>
						<Col xs={12} md={6} className="d-flex my-4">
							<div className="text-primary display-3 display-bold mx-3 d-flex align-items-start p-1">
								4.
							</div>
							<div>
								<b>
									<u>Elintézzük helyetted:</u>
								</b>{" "}
								Például egy hitelügylet esetén a teljes folyamat dokumentációs kezelését vállaljuk a
								hiteligénylés kitöltésétől a földhivatali ügyintézésig. (rengeted időt megtakarítva
								ezzel Neked)
							</div>
						</Col>
					</Row>
					<Row className="d-flex flex-column align-items-center">
						<AskUs />
						<Button size="lg" href="#askUsModal">
							Szeretném a Bankmonitor segítségét kérni!
						</Button>
					</Row>
				</LandingContainer>
				<Container className="justify-content-center align-items-center text-center">
					<div className="text-center small text-muted">
						*pénzpiaci többes ügynökök közül a közzétett 2022-es nettó árbevételek alapján
					</div>
				</Container>
			</>
		);
	}
}
